import Config from './config'
// import Effects from '../effects/effects'
// import Phaser from 'phaser'
import Planet from '../planet/planet'
import Ship from '../ship/ship'
// import Satellite from '../satellite/satellite'

const devSleep = () =>
    new Promise((resolve, reject) => {
        Config.gameStats.resources = 1000
        // Config.difficultyLevels.difficulty2.planetMineResourceDelay = 4000
        // const camera = Config.scene.cameras.main

        const homePlanet = new Planet({
            faction: Config.userFactionName,
            colonized: true,
            discovered: true,
            isHomePlanet: true,
            isMiningResources: true,
            x: 200,
            y: 200,
        })

        new Ship({
            faction: Config.userFactionName,
            orbitingEntity: homePlanet,
        })

        const enemyPlanet = new Planet({
            faction: Config.enemyFactionName,
            colonized: true,
            discovered: true,
            x: 200,
            y: 400,
        })

        new Ship({
            faction: Config.enemyFactionName,
            orbitingEntity: enemyPlanet,
        })
        // Config.scene.input.on('pointerdown', ({x, y}) => {
        //     // ships[0].destroy()
        // })

        // const ships = []
        // for (let i = 0; i < 8; i += 1) {
        //     new Ship({
        //         faction: Config.userFactionName,
        //         orbitingEntity: homePlanet,
        //         // x: 300,
        //         // y: 300,
        //     })
        //
        //     new Satellite({
        //         faction: Config.userFactionName,
        //         orbitingEntity: homePlanet,
        //     })
        // }

        return resolve({planet: homePlanet})
    })

export default devSleep
